export const environment = {
  production: false,
  apiBaseUrl: 'https://api-prod-20-cf.geoastra.com/api',
  // apiBaseUrl: 'http://localhost:5001/api',
  auth: {
    issuer: 'https://geoastra.us.auth0.com/',
    redirectUri: window.location.origin,
    clientId: 'LWQSdFDOO37kiZlQC8wAsdLKMau9dB0E',
    responseType: 'code',
    scope: 'openid profile read:userdata',
    showDebugInformation: true,
    silentRefreshRedirectUri: window.location.origin,
    useSilentRefresh: true,
    audience: 'https://prod-ntrip-caster-manager-apis.geoastra.com:5001/api',
  }
};
